import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26cc6f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-bind-loading" }
const _hoisted_2 = { class: "api-bind-loading-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/replenish/loading.png",
  alt: ""
}, null, -1))
const _hoisted_4 = ["innerHTML"]

import bus from '@/util/useBus'
import { t } from '@/plugins/i18n'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const show = ref(false)
bus.on('changeBindLoading', (k:boolean) => {
  show.value = k
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        innerHTML: _unref(t)('商品信息绑定中，请耐心等待...')
      }, null, 8, _hoisted_4)
    ])
  ], 512)), [
    [_vShow, show.value]
  ])
}
}

})